import React from 'react';

import { useIntl } from 'ha/i18n';
import { Link, Typography, Grid } from '@hbf/dsl';
import { AvailableLanguage } from '../types';

export interface Props {
  rel: string;
  availableLanguages: AvailableLanguage[];
}

const AvailableLanguages: React.FC<Props> = ({ rel, availableLanguages }) => {
  const { T } = useIntl();

  return (
    <Grid item xs={1} data-test-locator="Footer/AvailableLanguages">
      {availableLanguages.map(({ code, localisedText, localisedUrl }) => (
        <Link to={localisedUrl} key={code} rel={rel}>
          <Typography.Paragraph color="white">
            {T(localisedText)}
          </Typography.Paragraph>
        </Link>
      ))}
    </Grid>
  );
};

export { AvailableLanguages };
